import styles from "./ProspectInfoExpander.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Expander } from "shared/components/Expander/Expander";
import { AddButton } from "shared/components/AddButton/AddButton";
import { useTranslation } from "react-i18next";
import { ChevronRight } from "react-ikonate";

/**
 * Styled expander for Prospecting Info sections.
 */
export function ProspectInfoExpander({
  title,
  onAdd,
  isOpen,
  onToggle,
  children,
}) {
  const { t } = useTranslation();

  return (
    <Expander
      isOpen={isOpen}
      onToggle={onToggle}
      renderHeader={(open, setOpen) => (
        <div className={styles.header}>
          <span className={styles.title}>{title}</span>

          {onAdd && (
            <AddButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onAdd();
                setOpen(true);
              }}
            >
              {t("buttons.add")}
            </AddButton>
          )}

          <ChevronRight
            className={classNames(styles.caretIcon, {
              [styles.active]: open,
            })}
            width={34}
            height={34}
          />
        </div>
      )}
    >
      <div className={styles.content}>{children}</div>
    </Expander>
  );
}

ProspectInfoExpander.propTypes = {
  /**
   * Title of the section.
   */
  title: PropTypes.string.isRequired,

  /**
   * Callback to handle when the user clicks the "+ Add" button. If not passed, no "+ Add" button will be displayed.
   */
  onAdd: PropTypes.func,

  /**
   * Control expand/collapse status from outside.
   */
  isOpen: PropTypes.bool,
};
